import client from "./client";

export const pricingApi = {
  getPricing: () => client.get("/api/pricing"),
};
